// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CjyM","right":"styles_right__2k70J"};